import React, {useEffect} from "react";
import { animateScroll as scroll } from 'react-scroll';
import {
    TechStackCard,
    ProjectCard,
    ProjectCardTiny,
    ExperienceCard,
    OtherWorkCard,
    LinkCard,
} from "./Component";
import {Link} from "react-router-dom";

export default function Work() {
    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    return(
        <>
            <Projects />
            <Tech />
            <Experience />
            <Other />
        </>
    )
}

export function Projects(){
    return(
        <div className={'select-none'}>
            <div className={'pt-5 px-5 '}>
                <div className={'md:text-[36px] text-[24px] font-[600] flex'}>
                    <Link to={'/'}>
                        <img src={require("./back.png")} alt={'back'} className={'md:mt-3 mt-1 mr-2 w-[30px] h-[30px]'} />
                    </Link>
                    <span>Projects </span>
                </div>
            </div>
            <div className={'md:overscroll-contain md:snap-x px-5 md:scroll-smooth md:overflow-y-scroll md:flex pt-2 sm:flex'}>
                <div className={'md:snap-center md:w-[1000px] w-[300px]'}>
                    <ProjectCard title={'Tank Stars'}
                                 description={'A clone of mobile game tank stars using Java and LibGDX library'}
                                 path={"./Project/tank-star.png"}
                                 live={"false"}
                                 link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/Tank-Stars-Game"}
                    />
                </div>
                <div className={'md:snap-center md:w-[1000px] w-[300px]'}>
                    <ProjectCard title={'Living Lightly'}
                                 description={'Map based web application for Living Lightly organization'}
                                 path={"./Project/ll.png"}
                                 live={"true"}
                                 link={"https://livinglightly.vercel.app"}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/living-lightly"}
                    />
                </div>
            </div>
            <div className={'px-5 md:text-[24px] text-[16px] font-[600] flex pt-2'}>
                <span>Other small projects </span>
            </div>
            <div className={'grid md:grid-cols-3 grid-cols-2 sm:grid-cols-3 px-5 pt-5'}>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'Personal Projects'}
                                 description={'Collection of all my personal projects'}
                                 live={"false"} link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/personal-projects"}
                    />
                </div>                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'ACM Summer of Code'}
                                 description={'Website for SoC of ACM IIITD'}
                                 live={"true"} link={"https://acm-soc.vercel.app"}
                                 codeAvailable={"false"}
                                 codeLink={""}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'Shoppr'}
                                 description={'Clone of an online retail store with proper database management using MySQL'}
                                 live={"false"} link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/Shoppr"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'Custom Shell'}
                                 description={'Custom made UNIX shell using C'}
                                 live={"false"} link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/Shell"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'RISC Assembler-Simulator'}
                                 description={'Simple Assembler and Simulator in Python along with their memory plots'}
                                 live={"false"} link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/RISC-Assembler-Simulator"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'Retrieve Classroom Files'}
                                 description={'App to access all your classroom materials uploaded by your professors and TAs'}
                                 live={"false"} link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/Retrieve-Classroom-Files"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'AnveFund'}
                                 description={'Website used to fund research projects using CryptoCurrency'}
                                 live={"false"} link={""}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/Hanoon02/AnveFund"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'Sports Council IIITD'}
                                 description={'Official website for sports council IIITD'}
                                 live={"false"} link={""}
                                 codeAvailable={"false"}
                                 codeLink={""}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'Toonsutra'}
                                 description={'Indian based comic book app'}
                                 live={"true"} link={"https://yuvrajsingh808.github.io/toonsutra/"}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/YuvrajSingh808/toonsutra"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'MTech Induction(23) IIITD'}
                                 description={'Website for Induction of IIITD MTech Batch 2023'}
                                 live={"true"} link={"https://mtech-induction23.vercel.app"}
                                 codeAvailable={"true"}
                                 codeLink={"https://github.com/divyansh-4/mtech_induction23"}
                    />
                </div>
                <div className={'md:w-[300px] w-[100px]'}>
                    <ProjectCardTiny title={'AchieveIIITD'}
                                 description={'Maintained and Improved AchieveIIITD Portal'}
                                 live={"true"} link={"https://achieve.fh.iiitd.edu.in"}
                                 codeAvailable={"false"}
                                 codeLink={""}
                    />
                </div>
            </div>
        </div>
    )
}

export function Experience(){
    return(
        <div className={'select-none'}>
            <div className={'pt-5'}>
                <div className={'md:text-[36px] text-[24px] font-[600] px-5'}>
                    <span>Experience </span>
                </div>
            </div>
            <div className={'px-5 pt-2'}>
                <ExperienceCard title={'Software Engineer Intern'}
                                start={'June 2023'}
                                end={'July 2023'}
                                organization={'under the guidance of Dr. Pankaj Jalote'}
                                description={'Develop websites using different Generative AI tools and assess their performance'}
                />
                <ExperienceCard title={'Software Developer'}
                                start={'September 2022'}
                                end={'Present'}
                                organization={'MIDAS Labs, IIIT Delhi'}
                                description={'Develop AchieveIIITD portal and maintain Facility Hub portals of IIIT Delhi'}
                />
                <ExperienceCard title={'Software Developer Intern'}
                                start={'June 2023'}
                                end={'Present'}
                                organization={'under the guidance of Dr. Tapan Parikh'}
                                description={'Develop websites for Living Lightly org, Represent org and help in developing a MVC platform for the same'}
                />
            </div>
        </div>
    )
}

export function Other(){
    return(
        <div className={'select-none'}>
            <div className={'pt-5 px-5'}>
                <div className={'md:text-[36px] text-[24px] font-[600]'}>
                    <span>Other works and links</span>
                </div>
            </div>
            <div className={'md:px-5 px-2 py-2 grid md:grid-cols-2'}>
                <OtherWorkCard title={'Open Source Contributor'}
                               organization={'Wagtail'}
                               path={"./Other/wagtail.png"}
                               description={'Contributing to Wagtail CMS'}
                               link={"https://github.com/wagtail/wagtail/pulls?q=author%3AHanoon02"}
                />
                <OtherWorkCard title={'Founder'}
                               organization={'International Relations Council, IIITD'}
                               path={"./Other/wagtail.png"}
                               description={'IRC is the council body responsible for all international affairs of IIITD'}
                               link={"https://twitter.com/irc_iiitd?s=20"}
                />
            </div>
            <div className={'flex px-5 pb-2'}>
                <LinkCard title={'Leetcode'}
                          path={'./Link/lc.png'}
                          link={'https://leetcode.com/ahmedhanoon02/'}
                />
                <LinkCard title={'Codeforces'}
                          path={'./Link/cf.png'}
                          link={'https://codeforces.com/profile/hanoooon'}
                />
                <LinkCard title={'Résumé'}
                          path={'./Link/CV.png'}
                          link={'https://drive.google.com/file/d/1HdnA-_k8uGQWSNNAq2W7-bE6Gi6DCodg/view?usp=sharing'}
                />
            </div>
        </div>
    )
}

export function Tech(){
    return(
        <>
            <div className={'md:pt-5 pt-2 px-5 select-none'}>
                <div className={'md:text-[36px] text-[24px] font-[600]'}>
                    <span>Tech</span>
                </div>
                <div className={'grid md:grid-cols-6 grid-cols-3 md:py-5 py-2'}>
                    <TechStackCard title={'JavaScript'} path={"./Tech/JS.png"}/>
                    <TechStackCard title={'Java'} path={"./Tech/java.png"}/>
                    <TechStackCard title={'Python'} path={"./Tech/python.png"}/>
                    <TechStackCard title={'C++'} path={"./Tech/cpp.png"}/>
                    <TechStackCard title={'C'} path={"./Tech/c.png"}/>
                    <TechStackCard title={'ReactJS'} path={"./Tech/React.png"}/>
                    <TechStackCard title={'MongoDB'} path={"./Tech/mongoDB.png"}/>
                    <TechStackCard title={'NodeJS'} path={"./Tech/node.png"}/>
                    <TechStackCard title={'ExpressJS'} path={"./Tech/express.png"}/>
                    <TechStackCard title={'TailwindCSS'} path={"./Tech/tailwind.png"}/>
                    <TechStackCard title={'TypeScript'} path={"./Tech/ts.png"}/>
                    <TechStackCard title={'Git'} path={"./Tech/git.png"}/>
                    <TechStackCard title={'MySQL'} path={"./Tech/mysql.png"}/>
                </div>
            </div>
        </>
    )
}